import MSDDeliveryGuaranteePanel from './msd-delivery-guarantee-panel';

export default MSDDeliveryGuaranteePanel;
